import { type SupportedLocale, SUPPORTED_LOCALES } from '@abaninja/types';

import { DEFAULT_LOCALE } from './DEFAULT_LOCALE';

export function getBrowserLanguage(userLanguages?: readonly string[]): SupportedLocale {
  const preferredLanguages = userLanguages ?? window.navigator.languages;
  const availableUserLanguages = preferredLanguages
    .map((language) => language.split('-')[0])
    .filter((locale) => SUPPORTED_LOCALES.find((lang) => lang === locale));

  if (availableUserLanguages[0]) return availableUserLanguages[0] as SupportedLocale;

  return DEFAULT_LOCALE;
}
